<template>
  <v-dialog
    v-model="show"
    persistent
    width="1000px"
  >
    <v-card>
      <v-icon @click="onCancel" class="close-btn" >mdi-close</v-icon>
      <img
          alt="logo"
          height="80px"
          width="150px"
          :src="logo"
          id="images"
          class="loginTitle pa-6"
        />
      <v-card-title class="text-uppercase text-h5 font-weight-black pb-4">
        {{ $t('termsAndConditions.termAndConditionTitle') }}
      </v-card-title>
      <v-card-subtitle class="pt-2">
        <font style="font-size: small; ">{{ $t('termsAndConditions.readAndAgreeLabel') }} </font>
      </v-card-subtitle>
      <v-card-text class="text-center">
        <v-expansion-panels :mandatory="true">
          <v-expansion-panel class="pb-2" >
            <v-expansion-panel-header>
              <v-row align="center" justify="center">
                <font style="font-size:x-large; font-weight: bold;">{{ consentInfo.tcTypeDescription }}</font>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pdf-viewer" :id="'pdf-viewer'">
              <!-- PDF preview -->
                <pdf :src="docs.content" @num-pages="($event) => handlePageCount($event)"/>
                <pdf v-for="(page, index) in docs.pageCount"
                  :key="index"
                  :src="docs.content"
                  :page="index + 1"
                  :onload="assignEventListener()"
                  class="pdf-page"
                ></pdf>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-layout>
            <v-flex class="text-end pt-2">
              <v-btn text class="text-capitalize" small @click="downloadConsent(consentInfo)" :color="secondaryColor">
                <v-icon left :color="secondaryColor" size="14px" class="material-symbols-outlined">
                  download
                </v-icon>{{ $t('termsAndConditions.actions.downloadTnC') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions class="justify-end pb-4">
        <v-btn
          :color="primaryColor"
          class="text-capitalize font-weight-light white--text text-none"
          :disabled="acceptTermAndConditionCheckbox"
          @click="acceptConsentDetails"
        >
          {{ $t('termsAndConditions.actions.agreeAndConfirm')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import pdf from '@teckel/vue-pdf'
export default {
  name: 'ConsentPreview',
  components: {
    pdf
  },
  props: {
    consentInfo: {
      type: Object,
      default () {
        return {
          consentArray: [],
          isUpdateConsentAvailable: false
        }
      }
    }
  },
  data () {
    return {
      enableTCForceRead: this.$appSettings.defaultConfigurations.consentManagement.enableForceReadForAccountTC,
      docs: {},
      acceptTermAndConditionCheckbox: false,
      show: true
    }
  },
  created () {
    if (this.consentInfo) {
      this.acceptTermAndConditionCheckbox = this.enableTCForceRead
      this.docs = {
        content: `data:application/pdf;base64,${this.consentInfo.contents}#toolbar=0`,
        pageCount: []
      }
    }
  },
  methods: {
    handlePageCount (e) {
      if (e) {
        this.docs = { ...this.docs, pageCount: new Array(e) }
      }
    },
    handleScrollEvent (e) {
      if (e.target.scrollHeight - (e.target.clientHeight+10) <= Math.ceil(e.target.scrollTop) && this.enableTCForceRead) {
        this.acceptTermAndConditionCheckbox = false
      }
    },
    onCancel () {
      this.$emit('cancel', true)
    },
    acceptConsentDetails () {
      this.consentInfo.acceptTermAndConditionCheckbox = true
      this.$emit('acceptConsent', this.consentInfo)
      this.onCancel()
    },
    assignEventListener () {
      if (this.enableTCForceRead) {
        const viewerContainer = document.getElementById('pdf-viewer')
        if (viewerContainer) {
          viewerContainer.addEventListener('scroll', (e) => {
            this.handleScrollEvent(e)
          })
        }
      }
    },
    downloadConsent (consentInfo) {
      const base64ImageData = `data:application/pdf;base64,${consentInfo.contents}#toolbar=0`
      const fileName = `${consentInfo.tcTypeDescription}${this.$t('termsAndConditions.actions.downloadFileNameSuffix')}`
      const a = document.createElement('a')
      a.href = base64ImageData
      a.download = fileName
      a.click()
    }
  },
  beforeDestroy () {
    if (this.enableTCForceRead) {
      const viewerContainer = document.getElementById('pdf-viewer')
      if (viewerContainer) {
        viewerContainer.removeEventListener('scroll', this.handleScrollEvent)
      }
    }
  }
}
</script>

<style scoped>
.pdf-viewer {
  padding: 10px;
  overflow-y: scroll;
  height: 400px;
  width: 90%;
  text-align: center;
  outline-style: solid;
  outline-width: 5px;
  outline-color: rgba(0, 0, 0, 0.4);
  margin: 0px auto;
  background-color: #303134;
}
.pdf-page {
  margin-bottom: 25px;
}
/** scrollbar styles */
/* Works on Firefox */
.pdf-viewer {
  scrollbar-width: thin;
  scrollbar-color: lightgray transparent;
}
/* Works on Chrome, Edge, and Safari */
.pdf-viewer::-webkit-scrollbar {
  width: 5px;
}
.pdf-viewer::-webkit-scrollbar-thumb {
  background-color: lightgray;
  border-radius: 20px;
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #000000;
}
</style>
